module.exports = __webpack_public_path__ + "static/media/ZM.a4551f1b.png";